import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/single-door-fridge-service-bangalore", label: "Single Door Service" },
  { to: "/fridge-not-cooling-repair", label: "Not Cooling Repair" },
  { to: "/fridge-gas-refill-service-bangalore", label: "Gas Refill Service" },
];

const MiniFridgeService = () => (
  <FridgePageTemplate
    title="Mini Fridge Service in Bangalore"
    description="Mini fridge repair service in Bangalore for cooling, gas, compressor, and electrical issues."
    keywords="mini fridge service bangalore, mini refrigerator repair, small fridge repair"
    path="/mini-fridge-service-bangalore"
    bannerTitle="Mini Fridge Service"
    intro="Get quick doorstep mini fridge repair in Bangalore for compact refrigerators used at homes, offices, and rooms."
    highlights={[
      "Cooling and thermostat diagnosis",
      "Compressor and relay checks",
      "Gas leakage inspection",
      "Noise and wiring troubleshooting",
    ]}
    issues={[
      "Mini fridge not cooling",
      "Compressor not working",
      "Fridge making noise",
      "Power or wiring fault",
    ]}
    relatedLinks={relatedLinks}
  />
);

export default MiniFridgeService;
